import React, { useEffect, useState } from 'react';
import { Button, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const REDIRECT_SECONDS = 10;

function Unauthorized() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (countdown <= 0) {
      navigate('/', { replace: true });
      return;
    }
    const timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '40px',
    }}>
      <div style={{
        width: 80,
        height: 80,
        borderRadius: '50%',
        background: 'rgba(201, 169, 97, 0.12)',
        border: '2px solid rgba(201, 169, 97, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 24,
      }}>
        <LockOutlined style={{ fontSize: 36, color: '#c9a961' }} />
      </div>

      <Title level={3} style={{ color: 'var(--theme-primary)', marginBottom: 8 }}>
        Access Restricted
      </Title>

      <Paragraph style={{ fontSize: 15, color: 'var(--theme-textSecondary)', maxWidth: 400, marginBottom: 12 }}>
        This feature is not available for your access level.
        Please contact your administrator if you need access.
      </Paragraph>

      <Paragraph style={{ fontSize: 13, color: 'var(--theme-textSecondary)', marginBottom: 32 }}>
        Redirecting to Home in <strong>{countdown}</strong> second{countdown !== 1 ? 's' : ''}…
      </Paragraph>

      <Button
        type="primary"
        size="large"
        onClick={() => navigate('/', { replace: true })}
        style={{ borderRadius: 8 }}
      >
        ← Go Home Now
      </Button>
    </div>
  );
}

export default Unauthorized;
